import React, { useState } from 'react';
import { Button, Flex } from '@decisiv/ui-components';

import AdminPage from 'lib/admin-kit/components/AdminPage';
import AdminPanel from 'lib/admin-kit/components/AdminPanel';
import FormFields from 'lib/admin-kit/components/FormFields';
import ErrorBox from 'lib/admin-kit/components/ErrorBox';
import useAdminMutation from 'lib/admin-kit/hooks/useAdminMutation';

// Bespoke, not createAdminResource-based: there is exactly one
// portal.ai_settings row and no id-based routes (resource :ai_settings is
// a singular Rails resource) — the factory assumes an indexed collection,
// so this reuses its building blocks directly instead.
const FIELDS = [
  {
    name: 'default_daily_warn_usd',
    label: 'Default warn threshold ($/day per dealer)',
    type: 'text',
    helpMessage: 'Used for any dealer without its own override',
  },
  {
    name: 'default_daily_limit_usd',
    label: 'Default limit ($/day per dealer)',
    type: 'text',
    helpMessage: 'Calls are blocked once a dealer crosses this for the day',
  },
  {
    name: 'enabled',
    label: 'Enforce AI budget limits',
    type: 'checkbox',
  },
];

const ENDPOINT = '/internal_admin/admin_kit/ai_settings';

const AiSettingsEdit = ({ record }) => {
  const [formState, setFormState] = useState({
    default_daily_warn_usd: record.default_daily_warn_usd,
    default_daily_limit_usd: record.default_daily_limit_usd,
    enabled: record.enabled,
  });
  const [errors, setErrors] = useState([]);

  const { mutate, isSubmitting } = useAdminMutation({
    onSuccess: () => { window.location.href = ENDPOINT; },
    onError: (err) => {
      try {
        const body = JSON.parse(err.message);
        setErrors(body.errors ?? [err.message]);
      } catch (_) {
        setErrors([err.message]);
      }
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors([]);
    mutate(ENDPOINT, { method: 'PATCH', body: { ai_setting: formState } });
  };

  return (
    <AdminPage
      title="Edit AI Budget Settings"
      breadcrumbs={[
        { text: 'AI Budget Settings', href: ENDPOINT },
        { text: 'Edit' },
      ]}
    >
      <AdminPanel title="Details">
        <form onSubmit={handleSubmit}>
          <FormFields
            fields={FIELDS}
            formState={formState}
            setFormState={setFormState}
            displays={{}}
            setDisplays={() => {}}
          />
          <ErrorBox errors={errors} />
          <Flex gap={1} marginTop={3}>
            <Button
              text="Update Settings"
              kind="primary"
              loading={isSubmitting}
              loadingText="Saving…"
              disabled={isSubmitting}
              onClick={handleSubmit}
            />
            <Button text="Cancel" kind="secondary" onClick={() => { window.location.href = ENDPOINT; }} />
          </Flex>
        </form>
      </AdminPanel>
    </AdminPage>
  );
};

export default AiSettingsEdit;
